import type { FaireProductEntity } from "../../entity_types/product";

export const p_4gxhqeutq7: FaireProductEntity = {
  token: "p_4gxhqeutq7",
  type: "product",
  name: "RAYA LINEN MIDI STRAP DRESS",
  brandToken: "b_4o7hxpq095",
  brandName: "Sunday Morning",
  imageUrl:
    "https://cdn.faire.com/fastly/35c7f969768f12ff672bb340147141fb0c0f0e67655b974aeb37b1433c6557a7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8f3d2492d72756873cb51086603297f32c9badaf24b842dd51b7cd092be77fce.jpeg",
    "https://cdn.faire.com/fastly/ee704b6d75fe5a6dea25b138a7cd0721d90a50a4361faefd47ab214851911a63.jpeg",
    "https://cdn.faire.com/fastly/3d01c0c6c783f6087863fc1393f054490d29ce3e138c7a9e19d6849d8d0d75a2.jpeg",
    "https://cdn.faire.com/fastly/60d22b8e24bc3bdfeab7618342f081386f20b57cc6ff0dcd967dc5152db6761c.jpeg",
    "https://cdn.faire.com/fastly/d89dea36cd82387e3a09bd1a2a274f4bdcb5328ad9b60d22bb494d753173b7bb.jpeg",
  ],
  priceDollars: 97.5,
  description:
    "Our Raya mid-length linen dress is designed with a playful front tie and wide, supportive straps. Its sleeveless airy silhouette makes it perfect for warm weather activities, and works for lounging at home, Sunday brunch or a trip to the beach.",
  tags: [],
  msrpDollars: 195,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:52.000Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
